import React, { forwardRef } from "react";

import enterCupboard from "../../assets/video/prijzenkast_intro_1500.mp4";

import { Video } from "./components";

export type Props = {
  readonly onEnded: () => void;
  readonly onPlay: () => void;
  readonly isVisible: boolean;
};

const EnterCupboard = forwardRef<HTMLVideoElement, Props>((props, ref) => (
  <Video {...props} src={enterCupboard} ref={ref} />
));

export default EnterCupboard;
